import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';


//var ReactGA = require('react-ga');
//ReactGA.initialize('UA-99818693-1');

ReactDOM.render(
  <App />,
  document.getElementById('root')
  );
document.title="Brian Alvarez"



// WEBPACK FOOTER //
// ./src/index.js